import {
  HttpMethod_GET_getInstance2m1rvu4d8a2j3 as HttpMethod_GET_getInstance,
  ConnectionException1wjs7wwnknnfm as ConnectionException,
} from './fetch.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  fetch3uvmq4t9tt42y as fetch,
  httpHeaders3s629sxokj9k6 as httpHeaders,
} from './fetch.js.mjs';
import {
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  intercepted2ogpsikxxj4u0 as intercepted,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Duration__times_impl_sfuzvp2ze3ly07zbx9v as Duration__times_impl_sfuzvp,
  Duration5ynfiptaqcrg as Duration,
  _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry,
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { coerceAtMost31oazapy1u82u as coerceAtMost } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { printStackTrace214c8iyv3cpiv5 as printStackTrace2 } from './debugger.js.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { System_instance3dr57gee6r420 as System_instance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import {
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  DurationUnit_MINUTES_getInstancejlptjvjgjkm8 as DurationUnit_MINUTES_getInstance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Companion_getInstanceok5aued8gko9 as Companion_getInstance_0 } from './debugger.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_connectivityFetch__st7prj(url, method, headers, body, $completion) {
  method = method === VOID ? HttpMethod_GET_getInstance() : method;
  var tmp;
  if (headers === VOID) {
    tmp = connectivityFetch$slambda_0();
  } else {
    tmp = headers;
  }
  headers = tmp;
  var tmp_0;
  // Inline function 'kotlin.js.getCoroutineContext' call
  if ($completion.pc().cd(Key_instance) == null) {
    var tmp_1 = Connectivity_getInstance().ncw_1;
    var tmp_2 = method.toString() + ' ' + url;
    var tmp_3 = tmp_1.wcw(tmp_2, connectivityFetch$slambda_2(url, method, headers, body), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  } else {
    var tmp_4 = headers($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    var tmp_5 = fetch(url, method, tmp_4, body, VOID, VOID, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    tmp_0 = tmp_5;
  }
  return tmp_0;
}
function connectivityFetch(url, method, headers, body, $completion) {
  method = method === VOID ? HttpMethod_GET_getInstance() : method;
  var tmp;
  if (headers === VOID) {
    tmp = connectivityFetch$slambda_0();
  } else {
    tmp = headers;
  }
  headers = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_connectivityFetch__st7prj.bind(VOID, url, method, headers, body), $completion);
}
function *_generator_invoke__zhh2q8($this, ms, $completion) {
  var tmp = delay(ms, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var d = $this.xcw_1.tcw_1;
  $this.xcw_1.vcw_1.mam($this.xcw_1.pcw_1.d1m().u26(d));
  $this.xcw_1.tcw_1 = coerceAtMost(new (Duration())(Duration__times_impl_sfuzvp(d, 2)), new (Duration())($this.xcw_1.ucw_1)).nj_1;
  $this.xcw_1.rcw_1.acx(false);
  var tmp = $this.xcw_1.qcw_1(_Duration___get_inWholeMilliseconds__impl__msfiry(d), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.xcw_1.bcx();
  return Unit_instance;
}
function *_generator_run__cb7u2f($this, tag, action, $completion) {
  while (true) {
    var tmp = $this.rcw_1.ea4($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    try {
      var tmp_0 = action($completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var r = tmp_0;
      $this.tcw_1 = $this.scw_1;
      return r;
    } catch ($p) {
      if ($p instanceof ConnectionException()) {
        var e = $p;
        printStackTrace2(e);
        if ($this.vcw_1.f2() == null) {
          var tmp_1 = get_AppScope();
          launch(tmp_1, VOID, VOID, ConnectivityGate$run$slambda_0($this));
        }
      } else {
        throw $p;
      }
    }
  }
}
var ConnectivityGate$_init_$slambda_l7pv2uClass;
function ConnectivityGate$_init_$slambda_l7pv2u() {
  if (ConnectivityGate$_init_$slambda_l7pv2uClass === VOID) {
    class $ {
      ccx(ms, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, ms), $completion);
      }
      s2(p1, $completion) {
        return this.ccx((!(p1 == null) ? typeof p1 === 'bigint' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ConnectivityGate$_init_$slambda_l7pv2uClass = $;
  }
  return ConnectivityGate$_init_$slambda_l7pv2uClass;
}
function ConnectivityGate$_init_$slambda_l7pv2u_0() {
  var i = new (ConnectivityGate$_init_$slambda_l7pv2u())();
  var l = (ms, $completion) => i.ccx(ms, $completion);
  l.$arity = 1;
  return l;
}
var ConnectivityGate$run$slambdaClass;
function ConnectivityGate$run$slambda() {
  if (ConnectivityGate$run$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.xcw_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ConnectivityGate$run$slambdaClass = $;
  }
  return ConnectivityGate$run$slambdaClass;
}
function ConnectivityGate$run$slambda_0(this$0) {
  var i = new (ConnectivityGate$run$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ConnectivityGateClass;
function ConnectivityGate() {
  if (ConnectivityGateClass === VOID) {
    class $ {
      constructor(clock, delay) {
        clock = clock === VOID ? System_instance : clock;
        var tmp;
        if (delay === VOID) {
          tmp = ConnectivityGate$_init_$slambda_l7pv2u_0();
        } else {
          tmp = delay;
        }
        delay = tmp;
        this.pcw_1 = clock;
        this.qcw_1 = delay;
        this.rcw_1 = new (WaitGate())(true);
        var tmp_0 = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance();
        tmp_0.scw_1 = toDuration(10, DurationUnit_SECONDS_getInstance());
        this.tcw_1 = this.scw_1;
        var tmp_1 = this;
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance();
        tmp_1.ucw_1 = toDuration(5, DurationUnit_MINUTES_getInstance());
        this.vcw_1 = Signal().fak(null);
      }
      bcx() {
        this.vcw_1.mam(null);
        this.rcw_1.acx(true);
      }
      wcw(tag, action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_run__cb7u2f.bind(VOID, this, tag, action), $completion);
      }
    }
    initMetadataForClass($, 'ConnectivityGate', ConnectivityGate, VOID, VOID, [2]);
    ConnectivityGateClass = $;
  }
  return ConnectivityGateClass;
}
var ConnectivityClass;
function Connectivity() {
  if (ConnectivityClass === VOID) {
    class $ {
      constructor() {
        Connectivity_instance = this;
        this.kcw_1 = setOf([502, 503]);
        this.lcw_1 = setOf([420, 429]);
        this.mcw_1 = plus(this.kcw_1, this.lcw_1);
        this.ncw_1 = new (ConnectivityGate())();
        this.ocw_1 = Signal().fak(0);
      }
    }
    initMetadataForObject($, 'Connectivity');
    ConnectivityClass = $;
  }
  return ConnectivityClass;
}
var Connectivity_instance;
function Connectivity_getInstance() {
  if (Connectivity_instance === VOID)
    new (Connectivity())();
  return Connectivity_instance;
}
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
function *_generator_await__mos7q6($this, $completion) {
  if ($this.ycw_1)
    return Unit_instance;
  else {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.ra5();
    $this.zcw_1.v(cancellable);
    var tmp$ret$1 = cancellable.sa5();
    var tmp = returnIfSuspended(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    return Unit_instance;
  }
}
var WaitGateClass;
function WaitGate() {
  if (WaitGateClass === VOID) {
    class $ {
      constructor(permit) {
        permit = permit === VOID ? false : permit;
        this.ycw_1 = permit;
        this.zcw_1 = ArrayList().w();
      }
      acx(value) {
        this.ycw_1 = value;
        if (value) {
          var _iterator__ex2g4s = this.zcw_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var continuation = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
            continuation.rc(tmp$ret$0);
          }
          this.zcw_1.v3();
        }
      }
      ea4($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_await__mos7q6.bind(VOID, this), $completion);
      }
    }
    initMetadataForClass($, 'WaitGate', WaitGate, VOID, VOID, [0]);
    WaitGateClass = $;
  }
  return WaitGateClass;
}
var connectivityFetch$slambdaClass;
function connectivityFetch$slambda() {
  if (connectivityFetch$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        return httpHeaders();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    connectivityFetch$slambdaClass = $;
  }
  return connectivityFetch$slambdaClass;
}
function connectivityFetch$slambda_0() {
  var i = new (connectivityFetch$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.fcx_1($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = fetch($this.dcx_1, $this.ecx_1, tmp_0, $this.gcx_1, VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  } catch ($p) {
    var tmp_2;
    if ($p instanceof ConnectionException()) {
      var e = $p;
      Companion_getInstance_0().gcv(['Forced retry on ' + $this.ecx_1.toString() + ' ' + $this.dcx_1]);
      var tmp_3;
      try {
        var tmp_4 = $this.fcx_1($completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        var tmp_5 = fetch($this.dcx_1, $this.ecx_1, tmp_4, $this.gcx_1, VOID, VOID, $completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        tmp_3 = tmp_5;
      } catch ($p) {
        var tmp_6;
        if ($p instanceof ConnectionException()) {
          var e_0 = $p;
          Connectivity_getInstance().ocw_1.mam(0);
          throw e_0;
        } else {
          throw $p;
        }
      }
      var r = tmp_3;
      if (Connectivity_getInstance().mcw_1.t1(r.jcx())) {
        Connectivity_getInstance().ocw_1.mam(r.jcx());
        throw ConnectionException().mcx('Status code ' + r.jcx());
      }
      tmp_2 = r;
    } else {
      throw $p;
    }
    tmp = tmp_2;
  }
  return tmp;
}
var connectivityFetch$slambdaClass_0;
function connectivityFetch$slambda_1() {
  if (connectivityFetch$slambdaClass_0 === VOID) {
    class $ {
      constructor($url, $method, $headers, $body) {
        this.dcx_1 = $url;
        this.ecx_1 = $method;
        this.fcx_1 = $headers;
        this.gcx_1 = $body;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    connectivityFetch$slambdaClass_0 = $;
  }
  return connectivityFetch$slambdaClass_0;
}
function connectivityFetch$slambda_2($url, $method, $headers, $body) {
  var i = new (connectivityFetch$slambda_1())($url, $method, $headers, $body);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: init
Key_instance = new (Key())();
//endregion
//region block: exports
export {
  connectivityFetch as connectivityFetch3ow9vj797ywad,
  Connectivity_getInstance as Connectivity_getInstance33ghnmuved25k,
};
//endregion

//# sourceMappingURL=fetch-connectivity.mjs.map
